import { render, staticRenderFns } from "./excelExport.vue?vue&type=template&id=06c0581e&"
import script from "./excelExport.vue?vue&type=script&lang=js&"
export * from "./excelExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports